import { render, staticRenderFns } from "./OrganisationSettings.vue?vue&type=template&id=23f5f019&"
import script from "./OrganisationSettings.vue?vue&type=script&lang=js&"
export * from "./OrganisationSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports